import { render, staticRenderFns } from "./HistoryOfChangesTableItem.vue?vue&type=template&id=fdfa2898"
import script from "./HistoryOfChangesTableItem.vue?vue&type=script&lang=js"
export * from "./HistoryOfChangesTableItem.vue?vue&type=script&lang=js"
import style0 from "./HistoryOfChangesTableItem.vue?vue&type=style&index=0&id=fdfa2898&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports